import { isImpersonationSession } from 'utils/auth/impersonation-storage';

/**
 * Returns whether editing should be restricted for the current session.
 * Currently restricted for impersonation sessions — agents viewing a
 * member's account should not be able to modify profile settings.
 */
export const isEditRestricted = (): boolean => isImpersonationSession();
